<template>
<div class="chapter">
<div class="inner_page">
<p class="poem3" id="epigraph"><a id="start"><i>Parlez moi d’amour,</i></a></p><a id="start">
<p class="poem3"><i>Redites, moi des choses tendres.</i></p>
<p class="poem3"><i>Votre beau discours,</i></p>
<p class="poem3"><i>Mon coeur n’est pas las de l’entendre…</i></p>
<p class="poem3"><i>Pourvu que toujours vous répétiez ces mots suprêmes,</i></p>
<p class="poem3"><i>Je vous aime…</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5epigraph.vue?46afd30f